<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <div class="footer-logo">
              <img src="@/assets/images/commons/icon.png" alt="logo">
            </div>
              <p style=" display: flex;flex-direction: row;align-items: flex-end;"><img src="@/assets/images/commons/companyIcon.png" alt="" style="margin-right: 16px;width: 28px;height: 28px;">江苏友辰工程装备有限公司</p>
            <p class="footer-desc">我们是一家专注于提供高质量产品和服务的企业，致力于为客户创造价值，为社会做出贡献。</p>
            <div style="width: 103px;height: 103px;"></div>
           <!-- <img src="@/assets/images/commons/code.png" alt="" style="width: 103px;height: 103px;"> -->
          </div>
          <div class="footer-links">
            <h3>快速链接</h3>
            <ul>
              <li v-for="(item, index) in navItems" :key="index">
                <router-link :to="item.path">{{ item.name }}</router-link>
              </li>
            </ul>
          </div>
          <div class="footer-contact">
            <h3>联系我们</h3>
            <ul>
              <li><i class="el-icon-location"></i> 地址：江苏省南京市溧水区白马镇锁塘路5号</li>
              <li><i class="el-icon-phone"></i> 电话：025-57215598</li>
              <li><i class="el-icon-message"></i> 邮箱：yc@ycepc.cn</li>
              <li><i class="el-icon-alarm-clock"></i> 工作时间：周一至周五 9:00-18:00</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <p>&copy; {{ new Date().getFullYear() }} 江苏友辰工程装备有限公司. 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2025189700号-1</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      navItems: [
        { name: '首页', path: '/' },
        { name: '关于我们', path: '/about' },
        { name: '产品服务', path: '/products' },
        { name: '经典案例', path: '/cases' },
        { name: '新闻资讯', path: '/news' },
        { name: '联系我们', path: '/contact' }
      ]
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #1a1a1a;
  color: #fff;
  margin-top: auto;
  width: 100%;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer-top {
  padding: 60px 0 40px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.footer-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo img {
  height: 50px;
}

.footer-desc {
  color: #ccc;
  line-height: 1.6;
}

.footer-social {
  display: flex;
  gap: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: #1e50a2;
}

.footer-links h3,
.footer-contact h3 {
  font-size: 20px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-links h3:after,
.footer-contact h3:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 2px;
  background-color: #1e50a2;
}

.footer-links ul li,
.footer-contact ul li {
  margin-bottom: 10px;
}

.footer-links ul li {
  margin-bottom: 8px;
}

.footer-links ul li a {
  color: #ccc;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.footer-links ul li a:hover {
  color: #1e50a2;
  padding-left: 5px;
}

.footer-contact ul li {
  color: #ccc;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.footer-contact ul li i {
  margin-top: 5px;
}

.footer-bottom {
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.footer-bottom p {
  color: #999;
  font-size: 14px;
}

.footer-bottom a {
  color: #ccc;
  transition: all 0.3s ease;
}

.footer-bottom a:hover {
  color: #1e50a2;
}

@media (max-width: 768px) {
  .footer-top {
    padding: 40px 0 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .container {
    padding: 0 20px;
  }

  .footer-info, .footer-links, .footer-contact {
    text-align: center;
  }

  .footer-links h3:after,
  .footer-contact h3:after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-links ul li a {
    font-size: 0.85rem;
  }

  .footer-contact ul li {
    justify-content: center;
  }
}
</style>
